import React from 'react';
import Dropzone from 'react-dropzone-uploader'
import * as XLSX from 'xlsx';
import { connect } from 'react-redux';
import history from '../../history';
import SubHeader from './SubHeader';
import api from "../../api/api";
import uri from "../../variables/uri";
import { setLoading } from '../../actions/authAction';
import AlertModal from '../modals/AlertModal';

class UploadOrganization extends React.Component {
    state = {
        isOpenMessage: false,
        type:1,
        message: "",
        text: "",
    };
    // called every time a file's `status` changes
    handleChangeStatus = ({ meta, file }, status) => { console.log(status, meta, file) }

    // receives array of files that are done uploading when submit button is clicked
    handleSubmit = (files, allFiles) => {
        if (!this.props.isAuthen || (!this.props.auth.isAdmin)) {
            history.push(`/home/${localStorage.getItem('username')}`)
        } 
        this.props.setLoading(true);
        var file = allFiles[0].file;
        var reader = new FileReader();
        reader.readAsBinaryString(file, "UTF-8")
        reader.onload = async () => {
            var data = reader.result;
            let readedData = XLSX.read(data, { type: 'binary' });
            const wsname = readedData.SheetNames[0];
            const ws = readedData.Sheets[wsname];

            const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
            const excelArr = dataParse.filter((item, i) => item.length > 0 && i !== 0);

            const arrObj = [];
            excelArr.forEach(element => {
                arrObj.push({
                    CompanyCode: element[0],
                    OrganizationId: element[1],
                    OrganizationName: element[2],
                    OrganizationParentNode: element[3],
                    OrganizationLevelCode: element[4],
                    DoaLevelCode: element[5],
                    ManagerUserId: element[6],
                    OrganizationIDofDivision: element[7],
                    CostCenter: element[8],
                    CostCenterName: element[9]
                });
            });
            
            try{
                const response = await api.post('Upload/UploadOrganization', arrObj);

                if(response.status === 200) { 
                    this.setState({isOpenMessage: true, message:'Uploaded Successfully.', type:1})
                    this.props.setLoading(false);
                }
            }catch(ex){
                this.props.setLoading(false);
                this.setState({isOpenMessage: true, message:'Upload Failed.', type:3})
            }
            
        };

        console.log(files.map(f => f.meta));
        allFiles.forEach(f => f.remove());
    }

    onClose = () =>{
        this.setState({isOpenMessage: false});
    }
    
    render() {
        return (
            <div className="flex-v home">
            <SubHeader text={`Upload Organization`} />
                <div className="card">
                    <div className="card-content p-24">
                        <Dropzone
                            onChangeStatus={this.handleChangeStatus}
                            onSubmit={this.handleSubmit}
                            accept=".csv,.xls,.xlsx"
                            maxFiles={1}
                            multiple={false}
                            inputContent="Drag File or Click to Browse"
                        />
                    </div>
                </div>
                <AlertModal isOpen={this.state.isOpenMessage} message={this.state.message} onClose={this.onClose} type={this.state.type} />
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        bookList: state.doa.bookList,
        permissionList: state.doa.permissionList,
        isAuthen: state.auth.isAuthen,
        auth: state.auth,
    }
}
export default connect(mapStateToProps, {
    setLoading
})(UploadOrganization)